import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  followUpTitle: {
    fontSize: 18,
    fontWeight: theme.typography.fontWeightMedium,
    margin: theme.spacing(2, 0)
  }
}));
